import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios";

const controller = 'ProtocolsEF';

const getProtocolEF = (aooId: number, uorId: number, protocolSPId: number, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.get(`${controller}/${aooId}/${uorId}/GetProtocolEF/${protocolSPId}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

export default {
    getProtocolEF
}